<script>
export default {
	props: {
    time: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
	},
  data() {
    return {
      
    }
  },
  methods: {
    countDownFinish() {
      this.$emit('finish')
    }
  }
}
</script>

<template>
  <div :class="$style.baseCountDown">
    <el-statistic 
    :value="time" 
    time-indices
    format="mm:ss"
    :class="className"
    @finish="countDownFinish"
    >
      <template slot="prefix"> 倒數中 <i class="fontello fontello-time"></i> </template>
    </el-statistic>
  </div>
</template>

<style lang="scss" module>
.baseCountDown {
  
}
</style>